const initialState = {
    isModalVisible: false,
  };
  
  const paymentOptionModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_PAYMENT_OPTION_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_PAYMENT_OPTION_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default paymentOptionModalReducer;
  